
import { CompanyDossierService } from "@/services";
import Vue from "vue";

export default Vue.extend({
	data(){
		return {
			bookyear: new Date().getFullYear(),
			submitting: false
		};
	},
	props: {
		dossierId: {
			type: Number,
			required: true
		}
	},
	methods: {
		close(){
			this.$emit("close");
		},
		async confirm(){
			if (this.submitting) return;
			try{
				this.submitting = true;
				let result = await CompanyDossierService.fixSaleActions(this.dossierId, this.bookyear);
				this.$wf.notify(`${result.RowsChanged} rijen geupdate`, "success", 3000, "check");
				this.close();
			}catch(err){

			}finally{
				this.submitting = false;
			}
		}
	}
});
